// extracted by mini-css-extract-plugin
export var deleteModal = "_tk-0";